module.exports = __webpack_public_path__ + "media/images/up_arrow-743031eeaa35e19613e1a7ee4cab4091.gif";